import { getRsiTileSeries } from 'widgets/signalTiles/rsiTile/components/chart/series/rsiTileSeries';

const upperBoundary = 70;
const lowerBoundary = 30;

const series = getRsiTileSeries(lowerBoundary, upperBoundary);

const domain: [number, number] = [0, 100];

export const rsiTileProps = { upperBoundary, lowerBoundary, series, domain };
